/*
 * Awareness Avenue — Size 3 confirmation guard
 * Scope: Product pages only. Fail-open by design.
 */
(function () {
  'use strict';

  var DIALOG_ID = 'aa-size3-confirmation';
  var STYLE_ID = 'aa-size3-confirmation-styles';
  var bypassForms = new WeakSet();
  var pendingAction = null;
  var lastFocusedElement = null;

  var COPY = {
    en: {
      title: 'Please confirm your ring size',
      before: 'You\u2019ve selected ',
      after: ', the smallest available size for this ring. Is that correct?',
      confirm: 'Yes, this size is correct',
      change: 'Choose another size',
      close: 'Close'
    },
    de: {
      title: 'Bitte best\u00e4tigen Sie Ihre Ringgr\u00f6\u00dfe',
      before: 'Sie haben ',
      after: ', die kleinste verf\u00fcgbare Gr\u00f6\u00dfe f\u00fcr diesen Ring, ausgew\u00e4hlt. Ist das korrekt?',
      confirm: 'Ja, diese Gr\u00f6\u00dfe ist korrekt',
      change: 'Andere Gr\u00f6\u00dfe w\u00e4hlen',
      close: 'Schlie\u00dfen'
    },
    es: {
      title: 'Confirma tu talla de anillo',
      before: 'Has seleccionado ',
      after: ', la talla m\u00e1s peque\u00f1a disponible para este anillo. \u00bfEs correcta?',
      confirm: 'S\u00ed, esta talla es correcta',
      change: 'Elegir otra talla',
      close: 'Cerrar'
    },
    fr: {
      title: 'Veuillez confirmer votre taille de bague',
      before: 'Vous avez s\u00e9lectionn\u00e9 ',
      after: ', la plus petite taille disponible pour cette bague. Est-ce correct\u00a0?',
      confirm: 'Oui, cette taille est correcte',
      change: 'Choisir une autre taille',
      close: 'Fermer'
    },
    ja: {
      title: '\u30ea\u30f3\u30b0\u30b5\u30a4\u30ba\u3092\u3054\u78ba\u8a8d\u304f\u3060\u3055\u3044',
      before: '\u3053\u306e\u30ea\u30f3\u30b0\u3067\u6700\u5c0f\u306e\u30b5\u30a4\u30ba ',
      after: ' \u3092\u9078\u629e\u3057\u3066\u3044\u307e\u3059\u3002\u3053\u306e\u30b5\u30a4\u30ba\u3067\u3088\u308d\u3057\u3044\u3067\u3059\u304b\uff1f',
      confirm: '\u306f\u3044\u3001\u3053\u306e\u30b5\u30a4\u30ba\u3067\u6b63\u3057\u3044\u3067\u3059',
      change: '\u5225\u306e\u30b5\u30a4\u30ba\u3092\u9078\u3076',
      close: '\u9589\u3058\u308b'
    },
    nl: {
      title: 'Bevestig uw ringmaat',
      before: 'U hebt ',
      after: ', de kleinste beschikbare maat voor deze ring, geselecteerd. Klopt dat?',
      confirm: 'Ja, deze maat is correct',
      change: 'Een andere maat kiezen',
      close: 'Sluiten'
    }
  };

  function localeCopy() {
    var locale = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
    return COPY[locale] || COPY.en;
  }

  function normalizeText(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\u00df/g, 'ss')
      .toLowerCase()
      .replace(/[^a-z0-9\u3040-\u30ff\u4e00-\u9faf.]+/g, ' ')
      .trim();
  }

  function exactThree(value) {
    var normalized = String(value || '').trim();
    return /^3(?:\.0+)?$/.test(normalized) || /^us\s*:?\s*3(?:\s*\||\s*$)/i.test(normalized);
  }

  function positiveRingSizeLegend(fieldset) {
    var legend = normalizeText(fieldset.querySelector('legend') && fieldset.querySelector('legend').textContent);
    var names = [
      'ring size',
      'ring size us',
      'ringgrosse',
      'talla del anillo',
      'taille de bague',
      'ringmaat',
      '\u30ea\u30f3\u30b0\u30b5\u30a4\u30ba',
      '\u6307\u8f2a\u306e\u30b5\u30a4\u30ba'
    ];
    return names.some(function (name) {
      return legend.indexOf(name) !== -1;
    });
  }

  function numericOptionValue(label) {
    var text = String(label || '').trim().replace(',', '.');
    if (!/^\d+(?:\.\d+)?$/.test(text)) return null;
    var value = Number(text);
    return Number.isFinite(value) ? value : null;
  }

  function looksLikeRingSizeScale(fieldset) {
    var values = Array.prototype.map.call(
      fieldset.querySelectorAll('label.popover__value-option span, label.block-swatch span, label[for] > span'),
      function (span) { return numericOptionValue(span.textContent); }
    ).filter(function (value) { return value !== null; });

    var unique = Array.from(new Set(values));
    var inRingRange = unique.filter(function (value) { return value >= 3 && value <= 15; });
    return unique.indexOf(3) !== -1 && inRingRange.length >= 5 && Math.max.apply(Math, inRingRange) >= 6;
  }

  function selectedVariant(picker) {
    try {
      var script = picker.querySelector('script[data-variant]');
      return script ? JSON.parse(script.textContent) : null;
    } catch (error) {
      return null;
    }
  }

  function selectedOption(fieldset, picker) {
    var checked = fieldset.querySelector('input[data-option-position]:checked');
    if (!checked) return null;

    var label = checked.closest('label');
    var displayed = label ? label.textContent.trim() : String(checked.value || '').trim();
    var position = Number(checked.getAttribute('data-option-position'));
    var variant = selectedVariant(picker);
    var canonical = variant && Array.isArray(variant.options) && position > 0
      ? String(variant.options[position - 1] || '').trim()
      : displayed;

    return {
      canonical: canonical,
      displayed: displayed,
      fieldset: fieldset,
      variantId: variant && variant.id ? String(variant.id) : ''
    };
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return String(value).replace(/([ #;?%&,.+*~\':"!^$[\]()=>|/@])/g, '\\$1');
  }

  function sizeThreeContext(form) {
    if (!form) return null;
    var formId = form.getAttribute('id');
    if (!formId) return null;

    var picker = document.querySelector('variant-picker[form-id="' + cssEscape(formId) + '"]');
    if (!picker) return null;

    var fieldsets = picker.querySelectorAll('fieldset.variant-picker__option');
    for (var index = 0; index < fieldsets.length; index += 1) {
      var fieldset = fieldsets[index];
      var selection = selectedOption(fieldset, picker);
      if (!selection) continue;

      var crossMarketValue = /^us\s*:?\s*3(?:\s*\||\s*$)/i.test(selection.canonical);
      var ringSizeField = positiveRingSizeLegend(fieldset) || looksLikeRingSizeScale(fieldset) || crossMarketValue;

      if (ringSizeField && (exactThree(selection.displayed) || exactThree(selection.canonical))) {
        selection.form = form;
        selection.picker = picker;
        return selection;
      }
    }

    return null;
  }

  function productFormFromPath(path) {
    for (var index = 0; index < path.length; index += 1) {
      var node = path[index];
      if (!node || node.nodeType !== 1) continue;

      if (node.tagName === 'FORM' && /\/cart\/add(?:\.js)?(?:\?|$)/.test(node.getAttribute('action') || '')) {
        return node;
      }

      var formId = node.getAttribute && node.getAttribute('form');
      if (formId) {
        var linkedForm = document.getElementById(formId);
        if (linkedForm && linkedForm.tagName === 'FORM') return linkedForm;
      }

      if (node.closest) {
        var closestForm = node.closest('form[action*="/cart/add"]');
        if (closestForm) return closestForm;
      }
    }
    return null;
  }

  function acceleratedTarget(path) {
    var acceleratedTags = ['SHOPIFY-ACCELERATED-CHECKOUT', 'SHOP-PAY-WALLET-BUTTON', 'MORE-PAYMENT-OPTIONS-LINK'];
    var containsAccelerated = path.some(function (node) {
      return node && node.nodeType === 1 && (
        acceleratedTags.indexOf(node.tagName) !== -1 ||
        (node.classList && (
          node.classList.contains('shopify-payment-button') ||
          node.classList.contains('shopify-payment-button__button') ||
          node.classList.contains('shopify-payment-button__more-options')
        ))
      );
    });

    if (!containsAccelerated) return null;
    return path.find(function (node) {
      return node && node.nodeType === 1 && typeof node.click === 'function';
    }) || null;
  }

  function standardPurchaseTarget(path) {
    return path.find(function (node) {
      if (!node || node.nodeType !== 1) return false;
      if (node.tagName === 'BUTTON') return (node.getAttribute('type') || 'submit').toLowerCase() === 'submit';
      if (node.tagName === 'INPUT') return ['submit', 'image'].indexOf((node.getAttribute('type') || '').toLowerCase()) !== -1;
      return false;
    }) || null;
  }

  function track(name, context) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: name,
        aa_ring_size: context.displayed,
        aa_variant_id: context.variantId || '',
        aa_product_handle: context.picker.getAttribute('handle') || ''
      });
    } catch (error) {
      // Analytics must never affect purchasing.
    }
  }

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.aa-size3-confirmation{position:fixed;inset:0;z-index:2147483000;display:none;align-items:center;justify-content:center;padding:24px;background:rgba(0,0,0,.46)}',
      '.aa-size3-confirmation.is-open{display:flex}',
      '.aa-size3-confirmation__panel{position:relative;width:min(100%,440px);padding:30px;background:#fff;color:#1c1c1c;box-shadow:0 18px 60px rgba(0,0,0,.24)}',
      '.aa-size3-confirmation__close{position:absolute;top:12px;right:12px;width:36px;height:36px;border:0;background:transparent;color:inherit;font-size:25px;line-height:1;cursor:pointer}',
      '.aa-size3-confirmation__title{margin:0 36px 12px 0;font-family:var(--heading-font-family,inherit);font-size:22px;line-height:1.25;font-weight:500}',
      '.aa-size3-confirmation__text{margin:0 0 24px;font-size:15px;line-height:1.55}',
      '.aa-size3-confirmation__actions{display:grid;gap:10px}',
      '.aa-size3-confirmation__button{min-height:48px;width:100%;padding:12px 18px;border:1px solid #1c1c1c;font:inherit;font-weight:600;cursor:pointer}',
      '.aa-size3-confirmation__button--confirm{background:#1c1c1c;color:#fff}',
      '.aa-size3-confirmation__button--change{background:#fff;color:#1c1c1c}',
      '.aa-size3-confirmation__button:focus-visible,.aa-size3-confirmation__close:focus-visible{outline:2px solid #1c1c1c;outline-offset:3px}',
      '@media(max-width:699px){.aa-size3-confirmation{align-items:center;padding:20px}.aa-size3-confirmation__panel{width:100%;padding:26px 20px;border-radius:0}.aa-size3-confirmation__title{font-size:20px}}',
      '@media(prefers-reduced-motion:no-preference){.aa-size3-confirmation__panel{animation:aa-size3-in .16s ease-out}@keyframes aa-size3-in{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}}'
    ].join('');
    document.head.appendChild(style);
  }

  function buildDialog() {
    if (document.getElementById(DIALOG_ID)) return document.getElementById(DIALOG_ID);

    injectStyles();

    var overlay = document.createElement('div');
    overlay.id = DIALOG_ID;
    overlay.className = 'aa-size3-confirmation';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', DIALOG_ID + '-title');
    overlay.setAttribute('aria-describedby', DIALOG_ID + '-text');
    overlay.setAttribute('aria-hidden', 'true');
    overlay.innerHTML =
      '<div class="aa-size3-confirmation__panel" role="document">' +
        '<button type="button" class="aa-size3-confirmation__close" data-aa-size3-close aria-label="Close">&times;</button>' +
        '<h2 class="aa-size3-confirmation__title" id="' + DIALOG_ID + '-title"></h2>' +
        '<p class="aa-size3-confirmation__text" id="' + DIALOG_ID + '-text">' +
          '<span data-aa-size3-before></span><strong data-aa-size3-value></strong><span data-aa-size3-after></span>' +
        '</p>' +
        '<div class="aa-size3-confirmation__actions">' +
          '<button type="button" class="aa-size3-confirmation__button aa-size3-confirmation__button--confirm" data-aa-size3-confirm></button>' +
          '<button type="button" class="aa-size3-confirmation__button aa-size3-confirmation__button--change" data-aa-size3-change></button>' +
        '</div>' +
      '</div>';

    document.body.appendChild(overlay);
    return overlay;
  }

  function closeDialog(reason) {
    var dialog = document.getElementById(DIALOG_ID);
    if (!dialog) return;

    if (pendingAction && reason) track('size_3_confirmation_' + reason, pendingAction.context);
    dialog.classList.remove('is-open');
    dialog.setAttribute('aria-hidden', 'true');
    pendingAction = null;

    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus({ preventScroll: true });
    }
    lastFocusedElement = null;
  }

  function openDialog(action) {
    try {
      var dialog = buildDialog();
      var copy = localeCopy();

      dialog.querySelector('#' + DIALOG_ID + '-title').textContent = copy.title;
      dialog.querySelector('[data-aa-size3-before]').textContent = copy.before;
      dialog.querySelector('[data-aa-size3-value]').textContent = action.context.displayed;
      dialog.querySelector('[data-aa-size3-after]').textContent = copy.after;
      dialog.querySelector('[data-aa-size3-confirm]').textContent = copy.confirm;
      dialog.querySelector('[data-aa-size3-change]').textContent = copy.change;
      dialog.querySelector('[data-aa-size3-close]').setAttribute('aria-label', copy.close);

      pendingAction = action;
      lastFocusedElement = document.activeElement;
      dialog.classList.add('is-open');
      dialog.setAttribute('aria-hidden', 'false');
      dialog.querySelector('[data-aa-size3-confirm]').focus({ preventScroll: true });
      track('size_3_confirmation_shown', action.context);
      return true;
    } catch (error) {
      pendingAction = null;
      return false;
    }
  }

  function chooseAnotherSize() {
    if (!pendingAction) return;
    var context = pendingAction.context;
    track('size_3_confirmation_changed', context);
    closeDialog();

    var selector = context.fieldset.querySelector('button.select');
    if (selector) {
      selector.focus({ preventScroll: true });
      selector.click();
    } else {
      var selectedInput = context.fieldset.querySelector('input:checked');
      if (selectedInput) selectedInput.focus({ preventScroll: true });
    }
    context.fieldset.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  function confirmPendingAction() {
    if (!pendingAction) return;
    var action = pendingAction;
    track('size_3_confirmation_confirmed', action.context);
    closeDialog();

    try {
      bypassForms.add(action.form);
      if (action.type === 'submit') {
        action.form.requestSubmit(action.submitter || undefined);
      } else if (action.target && typeof action.target.click === 'function') {
        action.target.click();
      }
      window.setTimeout(function () { bypassForms.delete(action.form); }, 0);
    } catch (error) {
      // Never leave a form permanently bypassed after a failed replay.
      bypassForms.delete(action.form);
    }
  }

  function bindDialogEvents(dialog) {
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog || event.target.closest('[data-aa-size3-close]')) {
        closeDialog('dismissed');
      } else if (event.target.closest('[data-aa-size3-confirm]')) {
        confirmPendingAction();
      } else if (event.target.closest('[data-aa-size3-change]')) {
        chooseAnotherSize();
      }
    });

    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDialog('dismissed');
        return;
      }

      if (event.key === 'Tab') {
        var focusable = dialog.querySelectorAll('button:not([disabled])');
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });
  }

  function onSubmit(event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;
    if (!/\/cart\/add(?:\.js)?(?:\?|$)/.test(form.getAttribute('action') || '')) return;

    if (bypassForms.has(form)) {
      return;
    }

    var context = sizeThreeContext(form);
    if (!context) return;

    var opened = openDialog({
      type: 'submit',
      form: form,
      submitter: event.submitter || null,
      context: context
    });

    if (opened) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }

  function onPurchaseClick(event) {
    var path = typeof event.composedPath === 'function' ? event.composedPath() : [];
    var accelerated = acceleratedTarget(path);
    var target = accelerated || standardPurchaseTarget(path);
    if (!target) return;

    var form = productFormFromPath(path);
    if (!form) return;

    if (bypassForms.has(form)) {
      return;
    }

    var context = sizeThreeContext(form);
    if (!context) return;

    var opened = openDialog({
      type: accelerated ? 'accelerated' : 'purchase-click',
      form: form,
      target: target,
      context: context
    });

    if (opened) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }

  function init() {
    try {
      var dialog = buildDialog();
      bindDialogEvents(dialog);
      document.addEventListener('submit', onSubmit, true);
      document.addEventListener('click', onPurchaseClick, true);
    } catch (error) {
      // Fail open: native product forms remain untouched.
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
